export default function CarouselSlide({ speed, children }) {
    return (
        <div className="carousel-slide" style={{ animationDuration: speed}}>    
            {children}
        </div>
    )
}